import React from 'react'
import { pureKeys } from '../../utils/helpers'
import H1 from '../Headings/H1'
import BaseContainer from '../BaseContainer'

export default function SupportCenterComp({ data }) {

  const { heading = '', description = '', slides = [], backgroundGrey } = data

  return (
    <div className={`${backgroundGrey?'bg-transparent mt-[40px] lg:mt-[80px] mb-[40px] lg:mb-[80px]':'bg-white py-[40px] lg:py-[80px]'}`}>
      <BaseContainer>
        {heading && <H1 className="text-center">{heading}</H1>}
        {description && <div className="text-ek-grey-500 text-center tracking-[0.64px] mt-4" dangerouslySetInnerHTML={{ __html: description }}></div>}
        <div className="grid gap-4 lg:gap-5 lg:grid-cols-4 mt-6 lg:mt-10 max-w-[900px] mx-auto">
          {slides.map(element => (
            <a href={element?.linkHref} target={element?.linkTarget} key={pureKeys(element?.title)} className={`${backgroundGrey ? "bg-white": ""} border border-ek-grey-200 hover:border-ek-grey-300 transition duration-500 rounded-lg p-5 lg:p-4 text-center flex justify-center items-center text-sm`}>
              {element?.icon && <img src={element?.icon} loading="lazy" alt={element?.title} className="mr-4" width={40} height={40} />}
              {element?.title && <span className="text-left text-black tracking-[0.56px]">{element?.title}</span>}
            </a>
          ))}
        </div>
      </BaseContainer>
    </div>
  )
}
